module.exports = __webpack_public_path__ + "media/site/images/products/omms-screen2-d8ff2b9b2092bcc1b766fff019fedb76.png";